import Button, { ButtonProps } from '@material-ui/core/Button';

const StyledButton = (buttonProps: ButtonProps) => {
    const { color, variant, style, ...otherProps } = buttonProps;

    return (
        <Button color={color} variant={variant} style={style} {...otherProps} />
    );

    /*
    let additionalStyle = {};

    if (color === 'primary') {
        if (variant === 'contained') {
            additionalStyle = {
                color: '#000000',
                backgroundColor: '#FFE3A9',
                border: '1px solid rgba(0, 0, 0, 0.2)'
            };
        } else if (variant === 'outlined') {
            additionalStyle = {
                color: '#000000',
                backgroundColor: '#FFFFFF',
                border: '1px solid rgba(0, 0, 0, 0.3)'
            };
        } else {
            additionalStyle = {
                color: '#000000',
                backgroundColor: '#FFFFFF'
            };
        }
    }

    const finalStyle = { ...additionalStyle, ...style };

    return (
        <Button color={color} variant={variant} style={finalStyle} {...otherProps} />
    );
    */
};

export default StyledButton;
